import { render } from "./BaseAlertList.vue?vue&type=template&id=3778e9fc"
import script from "./BaseAlertList.vue?vue&type=script&lang=js"
export * from "./BaseAlertList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__